export class ImageViewerValues {
    private _id: string;
    private _imageBase64: string;
    private _fileName: string;
    private _title?: string;
    private _allowEmail: boolean = true;

    constructor(id: string, imageBase64: string, fileName?: string, title?: string, allowEmail?: boolean) {
        this._id = id;
        this.imageBase64 = imageBase64;
        this.fileName = fileName;
        this.title = title;
        this.allowEmail = allowEmail ?? true;
    }

    public get id(): string {
        return this._id;
    }

    private set id(value: string) {
        this._id = value;
    }

    public get imageBase64(): string {
        return this._imageBase64;
    }

    private set imageBase64(value: string) {
        this._imageBase64 = value;
    }

    public get fileName(): string {
        return this._fileName;
    }

    private set fileName(value: string) {
        this._fileName = value;
    }

    public get title(): string {
        return this._title ?? this.fileName;
    }

    private set title(value: string) {
        this._title = value;
    }

    public get allowEmail(): boolean {
        return this._allowEmail;
    }

    private set allowEmail(value: boolean) {
        this._allowEmail = value;
    }
    /**
     * Implement toJSON so that the info is serialized in the desired format.
     * @returns any
     */
    public toJSON(): any {
        return {
            id: this._id,
            imageBase64: this._imageBase64,
            fileName: this.fileName,
            title: this.title
        };
    }
}
